import { useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import { useSelector, useDispatch } from 'react-redux'
import { clearError, selectErrorMessage } from '../../store/slices/errorSlice'

import 'react-toastify/dist/ReactToastify.css'

const Error = () => {
	const errorMessage = useSelector(selectErrorMessage)
	const dispatch = useDispatch()

	useEffect(() => {
		if (errorMessage) {
			toast.info(errorMessage)
			dispatch(clearError())
		}
	}, [dispatch, errorMessage])

	return <ToastContainer position="top-right" autoClose={2000} />
}

export default Error
